







import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'UCProductHeroSection',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
});
